export default "__VITE_ASSET__a472cfc2__"